export const FREE_EMAIL_DOMAINS = new Set([
  'aol.com',
  'bk.ru',
  'fastmail.com',
  'gmail.com',
  'gmx.com',
  'gmx.de',
  'gmx.net',
  'googlemail.com',
  'hey.com',
  'hotmail.co.uk',
  'hotmail.com',
  'icloud.com',
  'inbox.ru',
  'list.ru',
  'live.com',
  'mac.com',
  'mail.com',
  'mail.ru',
  'me.com',
  'msn.com',
  'outlook.com',
  'pm.me',
  'proton.me',
  'protonmail.com',
  'tuta.io',
  'tutanota.com',
  'web.de',
  'yahoo.co.uk',
  'yahoo.com',
  'yandex.com',
  'yandex.ru',
  'ymail.com',
  'zoho.com',
]);

export const normalizeDomain = (domain: string) => domain.trim().toLowerCase();

const DOMAIN_PATTERN = /^(?!-)[a-z0-9-]+(\.[a-z0-9-]+)+$/;

export const isValidDomain = (domain: string) => DOMAIN_PATTERN.test(normalizeDomain(domain));

export const isCorporateDomain = (domain: string) => {
  const normalized = normalizeDomain(domain);

  return isValidDomain(normalized) && !FREE_EMAIL_DOMAINS.has(normalized);
};

export const extractEmailDomain = (email: string) => {
  const [, domain = ''] = email.trim().toLowerCase().split('@');

  return domain;
};

export const emailMatchesDomain = (email: string, domain: string) =>
  extractEmailDomain(email) === normalizeDomain(domain);
